import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';


const TenantNameList = (props) => {
  if (!props.list.length) {
    return (
      <Typography align='center'>No Tenants</Typography>
    );
  } else {
    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              {
                <TableCell align='center' style={{ height: 48}}>{'By Tenants'}</TableCell>
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              props.list.map((item, idx) => {
                return (
                  <ListItem key={idx} button selected={idx === props.selected} style={{ borderBottom:'1px solid rgba(224, 224, 224, 1)', height: 48, textAlign: 'center' }}
                    onClick={() => props.handleSelected(idx)}
                  >
                    <ListItemText>{item.name}</ListItemText>
                  </ListItem>
                );
              })
            }
          </TableBody>
        </Table>
      </Paper>
    );
  }
};

TenantNameList.propTypes = {
  list: PropTypes.array.isRequired,
  selected: PropTypes.number.isRequired,
  handleSelected: PropTypes.func.isRequired
};

export default TenantNameList;
